/**
 * User Atoms - State management for User, Auth, and Profile
 *
 * NO LOCAL TYPES - All types come from types/api.ts or Supabase types
 */

import { atom } from "jotai";
import { JwtPayload, User as SupabaseUser } from "@supabase/supabase-js";
import type { Profile, ProfileWithRole, SystemRole } from "@/isomorphic/schemas";
import type { AtomStatus } from "@/frontend/types/atoms";

// ============================================================================
// AUTH ATOMS
// ============================================================================

export const userAtom = atom<SupabaseUser | null>(null);
export const sessionAtom = atom<JwtPayload | null>(null);
export const accessTokenAtom = atom<string | null>(null);
export const authStatusAtom = atom<"init" | "loading" | "authenticated" | "unauthenticated">("init");

// ============================================================================
// PROFILE ATOMS
// ============================================================================

export const currentProfileAtom = atom<Profile | null>(null);
export const profileLoadingStatusAtom = atom<AtomStatus>("init");
export const profileErrorCodeAtom = atom<number | null>(null);
export const userRoleAtom = atom<SystemRole | null>(null);

export const profileFormDataAtom = atom<{
  firstName: string;
  lastName: string;
  jobTitle: string;
  company: string;
  bio: string;
  phone: string;
  website: string;
  address: string;
  avatarPublicUrl: string;
}>({
  firstName: "",
  lastName: "",
  jobTitle: "",
  company: "",
  bio: "",
  phone: "",
  website: "",
  address: "",
  avatarPublicUrl: "",
});

// ============================================================================
// USER WORKSPACES ATOMS
// ============================================================================

export const userWorkspacesAtom = atom<Array<{ workspaceId: string; name: string | null; role: string }>>([]);
export const userWorkspacesStatusAtom = atom<AtomStatus>("init");

// ============================================================================
// ADMIN PROFILES ATOMS
// ============================================================================

export const adminProfilesAtom = atom<ProfileWithRole[]>([]);
export const adminProfilesStatusAtom = atom<AtomStatus>("init");

// ============================================================================
// NOTE: All action functions have been moved to actions/user-actions.ts
// This file now only contains atom definitions (state)
// ============================================================================
